// extracted by mini-css-extract-plugin
module.exports = {"cGreenAlpha10":"#e6faf5","cGreenBase":"#00cc9f","cProgressbar2":"#00a681","cProgressbar3":"#008265"};